/**
 * Ligas / leaderboards. PRIVADAS por defecto (opt-in explícito para aparecer).
 * El core solo ordena y asigna tramos; la visibilidad la decide la app.
 */

export interface LeaderboardEntry {
  playerId: string;
  xp: number;
  /** ¿El jugador consintió aparecer en tablas? Default: excluido. */
  opdedIn?: boolean;
  displayName?: string;
}

export interface RankedEntry extends LeaderboardEntry {
  rank: number;
}

/**
 * Ordena por XP desc, desempate por playerId (estable/determinista). Solo
 * incluye a quienes hicieron opt-in (privacidad por defecto).
 */
export function rankLeaderboard(entries: readonly LeaderboardEntry[]): RankedEntry[] {
  const visible = entries.filter((e) => e.opdedIn === true);
  const sorted = visible.toSorted((a, b) => {
    if (b.xp !== a.xp) {
      return b.xp - a.xp;
    }
    return a.playerId < b.playerId ? -1 : a.playerId > b.playerId ? 1 : 0;
  });
  return sorted.map((e, i) => ({ ...e, rank: i + 1 }));
}

export type LeagueTier = "bronze" | "silver" | "gold" | "diamond";

const TIERS: readonly LeagueTier[] = ["diamond", "gold", "silver", "bronze"];

/**
 * Asigna tramo por percentil dentro de una liga (promoción/descenso). El 10%
 * superior = diamond, siguiente 20% = gold, siguiente 30% = silver, resto bronze.
 */
export function assignTier(rank: number, total: number): LeagueTier {
  if (total <= 0) {
    return "bronze";
  }
  const pct = rank / total; // 0..1, menor = mejor
  if (pct <= 0.1) {
    return TIERS[0]!;
  }
  if (pct <= 0.3) {
    return TIERS[1]!;
  }
  if (pct <= 0.6) {
    return TIERS[2]!;
  }
  return TIERS[3]!;
}
